import { useDropdown } from '@calendly/ui/components/dropdown'
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons'
import { primaryColorL1 } from '@calendly/ui/theme'

import { useViewportFit } from 'hooks/useViewportFit'

import { FilterBody } from './filter_body'
import { DropdownButton, Container } from './styles'

export const DropdownFilter = ({ controlText, ...props }) => {
  const [toggle, Dropdown, isExpanded] = useDropdown()
  const { ref, rightConflict } = useViewportFit()

  return (
    <div>
      <DropdownButton onClick={toggle}>
        {controlText}
        {isExpanded
          ? <ArrowChevronUpMiniIcon color={primaryColorL1} />
          : <ArrowChevronDownMiniIcon color={primaryColorL1} />}
      </DropdownButton>
      <Dropdown>
        <Container
          data-component="filter-dropdown-menu"
          ref={ref}
          hasRightConflict={rightConflict}
        >
          <FilterBody {...props} toggleDropdown={toggle} />
        </Container>
      </Dropdown>
    </div>
  )
}
